var $f43313d21d3fd8e2$exports = {};
// Lenis Smooth Scroll
const $f43313d21d3fd8e2$var$lenis = new Lenis();
function $f43313d21d3fd8e2$var$raf(time) {
    $f43313d21d3fd8e2$var$lenis.raf(time);
    requestAnimationFrame($f43313d21d3fd8e2$var$raf);
}
requestAnimationFrame($f43313d21d3fd8e2$var$raf);
$f43313d21d3fd8e2$var$lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time)=>{
    $f43313d21d3fd8e2$var$lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);
//
const $f43313d21d3fd8e2$var$hamburgerBtn = document.querySelector("#hamburgerBtn");
const $f43313d21d3fd8e2$var$navbar = document.querySelector(".navbar");
const $f43313d21d3fd8e2$var$overlay = document.querySelector(".overlay");
const $f43313d21d3fd8e2$var$fadeElements = document.querySelectorAll(".has-fade");
const $f43313d21d3fd8e2$var$body = document.querySelector("body");
let $f43313d21d3fd8e2$var$prevScrollPos = 0; // Initialize the previous scroll position
const $f43313d21d3fd8e2$var$navbarHeight = $f43313d21d3fd8e2$var$navbar.offsetHeight; // Get the height of the navbar
let $f43313d21d3fd8e2$var$isHidden = false; // Initialize the hidden state of the navbar
let $f43313d21d3fd8e2$var$scrolledDistance = 0; // Initialize the distance scrolled since the navbar was hidden
window.onscroll = ()=>{
    let scrollEnd = window.innerHeight + window.scrollY >= document.body.offsetHeight;
    const currentScrollPos = window.scrollY;
    if (!$f43313d21d3fd8e2$var$body.classList.contains("lock-scroll")) {
        if (currentScrollPos > $f43313d21d3fd8e2$var$prevScrollPos && !scrollEnd) // Scrolling down
        {
            if (!$f43313d21d3fd8e2$var$isHidden && currentScrollPos > $f43313d21d3fd8e2$var$navbarHeight) {
                $f43313d21d3fd8e2$var$navbar.classList.add("hidden");
                $f43313d21d3fd8e2$var$isHidden = true;
            }
        } else if (scrollEnd) {
            $f43313d21d3fd8e2$var$navbar.classList.remove("hidden");
            $f43313d21d3fd8e2$var$isHidden = false;
            $f43313d21d3fd8e2$var$scrolledDistance = 0;
        } else // Scrolling up
        if ($f43313d21d3fd8e2$var$isHidden || currentScrollPos <= $f43313d21d3fd8e2$var$navbarHeight) {
            $f43313d21d3fd8e2$var$scrolledDistance += $f43313d21d3fd8e2$var$prevScrollPos - currentScrollPos;
            if ($f43313d21d3fd8e2$var$scrolledDistance >= $f43313d21d3fd8e2$var$navbarHeight || currentScrollPos <= $f43313d21d3fd8e2$var$navbarHeight) {
                $f43313d21d3fd8e2$var$navbar.classList.remove("hidden");
                $f43313d21d3fd8e2$var$isHidden = false;
                $f43313d21d3fd8e2$var$scrolledDistance = 0;
            }
        }
    }
    $f43313d21d3fd8e2$var$prevScrollPos = currentScrollPos;
};
$f43313d21d3fd8e2$var$hamburgerBtn.addEventListener("click", ()=>{
    let open = $f43313d21d3fd8e2$var$navbar.classList.toggle("open");
    if (open) {
        $f43313d21d3fd8e2$var$body.classList.add("lock-scroll");
        $f43313d21d3fd8e2$var$fadeElements.forEach((element)=>{
            element.classList.remove("fade-out");
            element.classList.add("fade-in");
        });
    } else {
        $f43313d21d3fd8e2$var$body.classList.remove("lock-scroll");
        $f43313d21d3fd8e2$var$fadeElements.forEach((element)=>{
            element.classList.remove("fade-in");
            element.classList.add("fade-out");
        });
    }
});
// Slider JS
const $f43313d21d3fd8e2$var$slideshowDuration = 4000;
const $f43313d21d3fd8e2$var$slideshow = $(".main-content .slideshow");
function $f43313d21d3fd8e2$var$slideshowSwitch(slideshow, index, auto) {
    let activeSlideImageLeft;
    let newSlideContentRight;
    let newSlideContentLeft;
    let newSlideImageToLeft;
    let newSlideImageToRight;
    let newSlideImageLeft;
    let newSlideImageRight;
    let newSlideLeft;
    let newSlideRight;
    if (slideshow.data("wait")) return;
    const slides = slideshow.find(".slide");
    slideshow.find(".pagination");
    const activeSlide = slides.filter(".is-active");
    const activeSlideImage = activeSlide.find(".image-container");
    const newSlide = slides.eq(index);
    const newSlideImage = newSlide.find(".image-container");
    const newSlideContent = newSlide.find(".slide-content");
    const newSlideElements = newSlide.find(".caption > *");
    if (newSlide.is(activeSlide)) return;
    newSlide.addClass("is-new");
    let timeout = slideshow.data("timeout");
    clearTimeout(timeout);
    slideshow.data("wait", true);
    const transition = slideshow.attr("data-transition");
    if (transition === "fade") {
        newSlide.css({
            display: "block",
            zIndex: 2
        });
        newSlideImage.css({
            opacity: 0
        });
        gsap.to(newSlideImage, {
            duration: 1,
            alpha: 1,
            onComplete: ()=>{
                newSlide.addClass("is-active").removeClass("is-new");
                activeSlide.removeClass("is-active");
                newSlide.css({
                    display: "",
                    zIndex: ""
                });
                newSlideImage.css({
                    opacity: ""
                });
                slideshow.find(".pagination").trigger("check");
                slideshow.data("wait", false);
                if (auto) {
                    timeout = setTimeout(()=>{
                        $f43313d21d3fd8e2$var$slideshowNext(slideshow, false, true);
                    }, $f43313d21d3fd8e2$var$slideshowDuration);
                    slideshow.data("timeout", timeout);
                }
            }
        });
    } else {
        if (newSlide.index() > activeSlide.index()) {
            newSlideRight = 0;
            newSlideLeft = "auto";
            newSlideImageRight = -slideshow.width() / 8;
            newSlideImageLeft = "auto";
            newSlideImageToRight = 0;
            newSlideImageToLeft = "";
            newSlideContentLeft = "auto";
            newSlideContentRight = 0;
            activeSlideImageLeft = -slideshow.width() / 4;
        } else {
            newSlideRight = "";
            newSlideLeft = 0;
            newSlideImageRight = "auto";
            newSlideImageLeft = -slideshow.width() / 8;
            newSlideImageToRight = "";
            newSlideImageToLeft = 0;
            newSlideContentLeft = 0;
            newSlideContentRight = "auto";
            activeSlideImageLeft = slideshow.width() / 4;
        }
        newSlide.css({
            display: "block",
            width: 0,
            right: newSlideRight,
            left: newSlideLeft,
            zIndex: 2
        });
        newSlideImage.css({
            width: slideshow.width(),
            right: newSlideImageRight,
            left: newSlideImageLeft
        });
        newSlideContent.css({
            width: slideshow.width(),
            left: newSlideContentLeft,
            right: newSlideContentRight
        });
        activeSlideImage.css({
            left: 0
        });
        TweenMax.set(newSlideElements, {
            y: 20,
            force3D: true
        });
        TweenMax.to(activeSlideImage, 1, {
            left: activeSlideImageLeft,
            ease: Power3.easeInOut
        });
        TweenMax.to(newSlide, 1, {
            width: slideshow.width(),
            ease: Power3.easeInOut
        });
        TweenMax.to(newSlideImage, 1, {
            right: newSlideImageToRight,
            left: newSlideImageToLeft,
            ease: Power3.easeInOut
        });
        TweenMax.staggerFromTo(newSlideElements, 0.8, {
            alpha: 0,
            y: 60
        }, {
            alpha: 1,
            y: 0,
            ease: Power3.easeOut,
            force3D: true,
            delay: 0.6
        }, 0.1, function() {
            newSlide.addClass("is-active").removeClass("is-new");
            activeSlide.removeClass("is-active");
            newSlide.css({
                display: "",
                width: "",
                left: "",
                zIndex: ""
            });
            newSlideImage.css({
                width: "",
                right: "",
                left: ""
            });
            newSlideContent.css({
                width: "",
                left: ""
            });
            newSlideElements.css({
                opacity: "",
                transform: ""
            });
            activeSlideImage.css({
                left: ""
            });
            slideshow.find(".pagination").trigger("check");
            slideshow.data("wait", false);
            if (auto) {
                timeout = setTimeout(function() {
                    $f43313d21d3fd8e2$var$slideshowNext(slideshow, false, true);
                }, $f43313d21d3fd8e2$var$slideshowDuration);
                slideshow.data("timeout", timeout);
            }
        });
    }
}
function $f43313d21d3fd8e2$var$slideshowNext(slideshow, previous, auto) {
    const slides = slideshow.find(".slide");
    const activeSlide = slides.filter(".is-active");
    let newSlide;
    if (previous) {
        newSlide = activeSlide.prev(".slide");
        if (newSlide.length === 0) newSlide = slides.last();
    } else {
        newSlide = activeSlide.next(".slide");
        if (newSlide.length === 0) newSlide = slides.filter(".slide").first();
    }
    $f43313d21d3fd8e2$var$slideshowSwitch(slideshow, newSlide.index(), auto);
}
function $f43313d21d3fd8e2$var$homeSlideshowParallax() {
    const windowHeight = $(window).height();
    const scrollTop = $(window).scrollTop();
    if (scrollTop > windowHeight) return;
    const inner = $f43313d21d3fd8e2$var$slideshow.find(".slideshow-inner");
    const newHeight = windowHeight - scrollTop / 2;
    const newTop = scrollTop * 0.8;
    inner.css({
        transform: "translateY(" + newTop + "px)",
        height: newHeight
    });
}
$(function() {
    $(".slide").addClass("is-loaded");
    $(".slideshow .arrows .arrow").on("click", function() {
        $f43313d21d3fd8e2$var$slideshowNext($(this).closest(".slideshow"), $(this).hasClass("prev"));
    });
    $(".slideshow .pagination .item").on("click", function() {
        $f43313d21d3fd8e2$var$slideshowSwitch($(this).closest(".slideshow"), $(this).index());
    });
    $(".slideshow .pagination").on("check", function() {
        const slideshow = $(this).closest(".slideshow");
        const pages = $(this).find(".item");
        const index = slideshow.find(".slides .is-active").index();
        pages.removeClass("is-active");
        pages.eq(index).addClass("is-active");
    });
    /* Lazyloading
    $('.slideshow').each(function(){
      var slideshow=$(this);
      var images=slideshow.find('.image').not('.is-loaded');
      images.on('loaded',function(){
        var image=$(this);
        var slide=image.closest('.slide');
        slide.addClass('is-loaded');
      });
    */ const timeout = setTimeout(function() {
        $f43313d21d3fd8e2$var$slideshowNext($f43313d21d3fd8e2$var$slideshow, false, true);
    }, $f43313d21d3fd8e2$var$slideshowDuration);
    $f43313d21d3fd8e2$var$slideshow.data("timeout", timeout);
});
if ($f43313d21d3fd8e2$var$slideshow.length > 1) $(window).on("scroll", $f43313d21d3fd8e2$var$homeSlideshowParallax);
const $f43313d21d3fd8e2$var$bg = document.querySelectorAll(".image");
gsap.to($f43313d21d3fd8e2$var$bg, {
    backgroundPosition: "50% -25%",
    ease: "none",
    scrollTrigger: {
        trigger: $f43313d21d3fd8e2$var$bg,
        start: "top bottom",
        end: "bottom top",
        scrub: true
    }
});
const $f43313d21d3fd8e2$var$DOM = {
    timeline: "timeline",
    timelineStepper: "timeline__stepper",
    timelineStep: "timeline__step",
    timelineStepTitle: "timeline__step-title",
    timelineStepActive: "is-active",
    timelineStepActiveMarker: "timeline__step-active-marker",
    timelineSlidesContainer: "timeline__slides",
    timelineSlide: "timeline__slide",
    timelineSlideActive: "is-active"
};
const $f43313d21d3fd8e2$var$STEP_ACTIVE_MARKEP_CUSTOM_PROPS = {
    width: "--slide-width",
    posX: "--slide-pos-x",
    posY: "--slide-pos-y"
};
const $f43313d21d3fd8e2$var$SLIDES_CONTAINER_CUSTOM_PROPS = {
    height: "--slides-container-height"
};
const $f43313d21d3fd8e2$var$timeline = document.querySelector(`.${$f43313d21d3fd8e2$var$DOM.timeline}`);
const $f43313d21d3fd8e2$var$timelineStepper = $f43313d21d3fd8e2$var$timeline?.querySelector(`.${$f43313d21d3fd8e2$var$DOM.timelineStepper}`);
const $f43313d21d3fd8e2$var$timelineStepTitle = $f43313d21d3fd8e2$var$timeline?.querySelector(`.${$f43313d21d3fd8e2$var$DOM.timelineStepTitle}`);
const $f43313d21d3fd8e2$var$timelineSlidesContainer = $f43313d21d3fd8e2$var$timeline?.querySelector(`.${$f43313d21d3fd8e2$var$DOM.timelineSlidesContainer}`);
const $f43313d21d3fd8e2$var$timelineSlides = $f43313d21d3fd8e2$var$timeline && Array.from($f43313d21d3fd8e2$var$timeline.querySelectorAll(`.${$f43313d21d3fd8e2$var$DOM.timelineSlide}`));
window.addEventListener("load", ()=>{
    $f43313d21d3fd8e2$var$createStepActiveMarker();
    $f43313d21d3fd8e2$var$activateCurrentSlide();
});
window.addEventListener("resize", ()=>{
    $f43313d21d3fd8e2$var$reCalcStepActiveMarkerProps();
});
$f43313d21d3fd8e2$var$timeline?.addEventListener("click", (event)=>{
    const { target: target } = event;
    if (!target || !(target instanceof Element) || !target.closest(`.${$f43313d21d3fd8e2$var$DOM.timelineStep}`)) return;
    const currentStep = target.closest(`.${$f43313d21d3fd8e2$var$DOM.timelineStep}`);
    if (!currentStep) return;
    $f43313d21d3fd8e2$var$deactivateSteps();
    $f43313d21d3fd8e2$var$activateCurrentStep(currentStep);
    $f43313d21d3fd8e2$var$reCalcStepActiveMarkerProps();
    $f43313d21d3fd8e2$var$deactivateSlides();
    $f43313d21d3fd8e2$var$activateCurrentSlide();
});
function $f43313d21d3fd8e2$var$deactivateSteps() {
    const steps = document.querySelectorAll(`.${$f43313d21d3fd8e2$var$DOM.timelineStep}`);
    steps?.forEach((elem)=>elem.classList.remove(`${$f43313d21d3fd8e2$var$DOM.timelineStepActive}`));
}
function $f43313d21d3fd8e2$var$activateCurrentStep(currentStep) {
    currentStep?.classList.add(`${$f43313d21d3fd8e2$var$DOM.timelineStepActive}`);
}
function $f43313d21d3fd8e2$var$deactivateSlides() {
    $f43313d21d3fd8e2$var$timelineSlides?.forEach((elem)=>elem.classList.remove(`${$f43313d21d3fd8e2$var$DOM.timelineSlideActive}`));
}
function $f43313d21d3fd8e2$var$activateCurrentSlide() {
    const currentSlide = $f43313d21d3fd8e2$var$getCurrentSlide();
    if (!currentSlide) return;
    const currentSlideHeight = $f43313d21d3fd8e2$var$getCurrentSlideHeight(currentSlide);
    $f43313d21d3fd8e2$var$setSlideContainerHeight(currentSlideHeight);
    currentSlide.classList.add(`${$f43313d21d3fd8e2$var$DOM.timelineSlideActive}`);
}
function $f43313d21d3fd8e2$var$createStepActiveMarker() {
    const stepActiveMarker = document.createElement("div");
    stepActiveMarker.classList.add(`${$f43313d21d3fd8e2$var$DOM.timelineStepActiveMarker}`);
    $f43313d21d3fd8e2$var$timelineStepper?.appendChild(stepActiveMarker);
    const positionProps = $f43313d21d3fd8e2$var$getStepActiveMarkerProps();
    if (!positionProps) return;
    $f43313d21d3fd8e2$var$setStepActiveMarkerProps({
        stepActiveMarker: stepActiveMarker,
        ...positionProps
    });
}
function $f43313d21d3fd8e2$var$reCalcStepActiveMarkerProps() {
    const stepActiveMarker = $f43313d21d3fd8e2$var$timeline?.querySelector(`.${$f43313d21d3fd8e2$var$DOM.timelineStepActiveMarker}`);
    const stepActiveMarkerProps = $f43313d21d3fd8e2$var$getStepActiveMarkerProps();
    if (!stepActiveMarkerProps) return;
    $f43313d21d3fd8e2$var$setStepActiveMarkerProps({
        stepActiveMarker: stepActiveMarker,
        ...stepActiveMarkerProps
    });
}
function $f43313d21d3fd8e2$var$setStepActiveMarkerProps({ stepActiveMarker: stepActiveMarker, posX: posX, posY: posY, width: width }) {
    stepActiveMarker.style.setProperty(`${$f43313d21d3fd8e2$var$STEP_ACTIVE_MARKEP_CUSTOM_PROPS.width}`, `${width}px`);
    stepActiveMarker.style.setProperty(`${$f43313d21d3fd8e2$var$STEP_ACTIVE_MARKEP_CUSTOM_PROPS.posX}`, `${posX}px`);
    if (typeof posY === "number") stepActiveMarker.style.setProperty(`${$f43313d21d3fd8e2$var$STEP_ACTIVE_MARKEP_CUSTOM_PROPS.posY}`, `${posY}px`);
}
function $f43313d21d3fd8e2$var$getStepActiveMarkerProps() {
    const { currentStep: currentStep } = $f43313d21d3fd8e2$var$getCurrentStep();
    if (!currentStep) return null;
    const width = $f43313d21d3fd8e2$var$getElementWidth(currentStep);
    const posX = $f43313d21d3fd8e2$var$getStepActiveMarkerPosX(currentStep);
    const posY = $f43313d21d3fd8e2$var$getStepActiveMarkerPosY();
    if (typeof posX !== "number" || typeof posY !== "number") return null;
    return {
        posX: posX,
        posY: posY,
        width: width
    };
}
function $f43313d21d3fd8e2$var$getCurrentStep() {
    const timelineSteps = Array.from(document.querySelectorAll(`.${$f43313d21d3fd8e2$var$DOM.timelineStep}`));
    const currentStep = timelineSteps.find((element)=>element.classList.contains(`${$f43313d21d3fd8e2$var$DOM.timelineStepActive}`));
    const currentStepIndex = currentStep && timelineSteps.findIndex((element)=>element.classList.contains(`${$f43313d21d3fd8e2$var$DOM.timelineStepActive}`));
    return {
        currentStep: currentStep,
        currentStepIndex: currentStepIndex
    };
}
function $f43313d21d3fd8e2$var$getCurrentSlide() {
    const { currentStepIndex: currentStepIndex } = $f43313d21d3fd8e2$var$getCurrentStep();
    if (typeof currentStepIndex !== "number" || !$f43313d21d3fd8e2$var$timelineSlides) return null;
    return $f43313d21d3fd8e2$var$timelineSlides[currentStepIndex];
}
function $f43313d21d3fd8e2$var$setSlideContainerHeight(height) {
    $f43313d21d3fd8e2$var$timelineSlidesContainer?.style.setProperty(`${$f43313d21d3fd8e2$var$SLIDES_CONTAINER_CUSTOM_PROPS.height}`, `${height}px`);
}
function $f43313d21d3fd8e2$var$getCurrentSlideHeight(currentSlide) {
    return currentSlide.clientHeight;
}
function $f43313d21d3fd8e2$var$getStepActiveMarkerPosY() {
    const timelineTitlePosY = $f43313d21d3fd8e2$var$timelineStepTitle?.getBoundingClientRect().top;
    const timelineStepperPosY = $f43313d21d3fd8e2$var$timelineStepper?.getBoundingClientRect().top;
    if (!timelineTitlePosY || !timelineStepperPosY) return null;
    return timelineTitlePosY - timelineStepperPosY;
}
function $f43313d21d3fd8e2$var$getStepActiveMarkerPosX(currentStep) {
    const timelineStepperPosX = $f43313d21d3fd8e2$var$timelineStepper?.getBoundingClientRect().left;
    const currentStepPosX = currentStep.getBoundingClientRect().left;
    if (!timelineStepperPosX) return null;
    return currentStepPosX - timelineStepperPosX;
}
function $f43313d21d3fd8e2$var$getElementWidth(elem) {
    return elem.clientWidth;
}
gsap.to("#parallax", {
    backgroundPosition: "50% 58%",
    y: -100,
    ease: "none",
    scrollTrigger: {
        trigger: "#parallax",
        start: "top bottom",
        end: "bottom top",
        scrub: true
    }
});
document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
    anchor.addEventListener("click", function(e) {
        e.preventDefault();
        $f43313d21d3fd8e2$var$navbar.classList.remove("open");
        $f43313d21d3fd8e2$var$fadeElements.forEach((element)=>{
            element.classList.remove("fade-in");
            element.classList.add("fade-out");
        });
        $f43313d21d3fd8e2$var$navbar.classList.add("hidden");
        $f43313d21d3fd8e2$var$body.classList.remove("lock-scroll");
        if (this.getAttribute("href") !== "#home") $f43313d21d3fd8e2$var$lenis.scrollTo(this.getAttribute("href"));
        else $f43313d21d3fd8e2$var$lenis.scrollTo(0, 0);
    });
});
$(".card").on("click", (e)=>{
    $(e.currentTarget).toggleClass("flip");
});
const $f43313d21d3fd8e2$var$year = new Date().getFullYear();
document.getElementById("year").innerText = String($f43313d21d3fd8e2$var$year);


//# sourceMappingURL=index.4fcdc18b.js.map
